export const BASE_DOMAIN = import.meta.env.VITE_BASE_DOMAIN;
export const BASE_DOMAIN_API = import.meta.env.VITE_BASE_DOMAIN_API;
export const BASE_API = import.meta.env.VITE_BASE_API;

export const LOGO_URL = `${BASE_DOMAIN}/images/logo/logo.png`;
export const LOGO_SQUARE_URL = `${BASE_DOMAIN}/images/logo/logoSquare.png`;

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

const MEDAN = {
    lat: 3.5952,
    lng: 98.6722,
};
const JAKARTA = {
    lat: -6.2146,
    lng: 106.8456,
};
export const DEFAULT_MAP_CENTER = MEDAN;

